import { Grid } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import Page from '../../layout/components/PageAuth';
import LogoColor from '../../assets/images/logo-master-color.png';
import Footer from '../../layout/components/FooterAuth';
import SetPasswordForm from './forms/SetPasswordForm';
import RightContent from './common/ContentRightLogin';
import { _route } from '../../utils';

function SetPassword() {
  return (
    <Page title="Register">
      <Grid container className="auth_view">
        <Grid item lg={6} md={12} sm={12} xs={12} className="auth_view_content customScrollbar">
          <div className="signup_holder">
            <div className="web_show">
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
            <div className="signin_link web_show">
              Already a member?
              <Link to={_route('login')} className="login_acc_link">
                Sign in
              </Link>
            </div>
          </div>
          <div className="mob_show">
            <div>
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
          </div>
          <div className="form_main_content">
            <div className="signup_form_holder">
              <div className="title_reg_right">Set Password</div>
              <p className="subtitle_reg_right web_show">And start growing your businesses.</p>

              <SetPasswordForm />

              <p className="sectionPara">
                By registering, I agree to SellerGeni's{' '}
                <a
                  underline="always"
                  color="text.primary"
                  href="https://sellergeni.com/terms-and-privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms & Privacy Policy
                </a>
                .
              </p>
            </div>
          </div>
          <Footer />
        </Grid>
        <RightContent />
      </Grid>
    </Page>
  );
}

export default SetPassword;
